import React from 'react';

const ExistenciaSucursal = (props) =>{
	const { sucursales, handler, existencias, resta } = props;
	let aux = {};
	let divs = []; 
	sucursales.forEach((item,index)=>{
		if( item.nombre !== 'Bodega' ){
			aux = existencias.find(e=>Number(e.id)===Number(item.id));
			if( ! aux ){
				aux = { existencia2 : 0, existencia : 0 }
			}
				divs.push(
					<div key={index}>
						<div className="sm-4 md-4 lg-4">
							<label>
								<span className="fixed">{item.nombre}</span>
								<input 
									type="number"
									onChange={e=>handler(e, item.id)}
									name="existencia" 
									value={aux.existencia2||''}
								/>
							</label>
						</div>
						<div className="sm-4 md-4 lg-4"><br/>
							<div className="input-text">{aux.existencia||0}</div>
						</div>
						<div className="sm-4 md-4 lg-4">
							<br/>
							<div>
								<div className="btn-small-2" onClick={()=>resta('+',item.id)}>Asignar</div>
								<div className="btn-small-2" onClick={()=>resta('-',item.id)}>Devolver</div>
							</div>
						</div>
					</div>
				);
		}
	})
	return(
		<>{divs}</>
	);
}
const ExistenciaSucursalNew = (props) =>{
	const { sucursales, handler, resta } = props;
	let divs = [];

	sucursales.forEach((item,index)=>{
		if( item.nombre !== 'Bodega' ){
			divs.push(
				<div key={index}>
					<div className="sm-4 md-4 lg-4">
						<label>
							<span className="fixed">{item.nombre}</span>
								<input 
									type="number"
									onChange={e=>handler(e, item.id)}
									name="existencia" 
									value={item.existencia2||0}
								/>
						</label>
					</div>
					<div className="sm-4 md-4 lg-4"><br/>
						<div className="input-text">{item.existencia||0}</div>
					</div>
					<div className="sm-4 md-4 lg-4">
						<br/>
						<div>
							<div className="btn-small-2" onClick={()=>resta('+',item.id)}>Asignar</div>
							<div className="btn-small-2" onClick={()=>resta('-',item.id)}>Devolver</div>
						</div>
					</div>
				</div>
			);
		}
	})
	return(
		<>{divs}</>
	);
}
const ModalView = (props) => {
	const { producto, show, closeModalView } = props;
	let sesion = JSON.parse( localStorage.getItem('sesion'));
	let sucursales = [];
	if( sesion.rol ===  1 ){
		producto.sucursales.forEach( (item, index) =>{
			sucursales.push(<div className="xs-12 sm-6 md-4 lg-4" key={index}>
				<p><strong>{item.nombre}: </strong></p>
				<p>{item.existencia} pieza(s)</p>
			</div>)
		})
	}else{
		producto.sucursales.forEach( (item, index) =>{
			if( parseInt(sesion.sucursal) === item.id ){
				sucursales.push(
					<div className="xs-12 sm-6 md-4 lg-4" key={index}>
						<p><strong>{item.nombre}: </strong></p>
						<p>{item.existencia2} pieza(s)</p>
					</div>
				);
			}
		});
	}
	return(
		<div className={ show ? 'overlay show':'overlay'}>
			<div className="row content">
				<div className="modal_header">
					<h5>DETALLES</h5>
					<span className="close-pop-up" onClick={closeModalView}>x</span>
				</div>
				<div className="modal_body">
					<div className="xs-12 sm-12 md-12 lg-12">
						<p><strong>Nombre: </strong> {producto.nombre}</p>
						<p><strong>Precio: </strong>{window.$fmoney(producto.precio,2)}</p>
						<p><strong>Descripcion: </strong>{producto.descripcion}</p>
						<p><strong>Proveedor: </strong>{producto.proveedor.nombre}</p>
					</div>
					<div className="xs-12 sm-12 md-12 lg-12 no-padding">
						<hr/>
						<div className="xs-12 sm-12 md-12 lg-12">
							<br/><h3>Existencia en sucursal</h3><br/>
						</div>
						<div>
							{sucursales}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
export {ExistenciaSucursal, ExistenciaSucursalNew, ModalView};